// extracted by mini-css-extract-plugin
export default {"icon-normal":"Icon_icon-normal__Zz7fo","icon-good":"Icon_icon-good__lF+TN","icon-bad":"Icon_icon-bad__aO9dz"};